import * as React from 'react';
import Svg, {
  Defs,
  LinearGradient,
  Path,
  Stop,
  SvgProps,
} from 'react-native-svg';

const SvgLogoTypeFa = (props: SvgProps) => (
  <Svg width={24} height={24} viewBox="0 0 86 86" fill="none" {...props}>
    <Path
      d="M43.344 54.61c1.847 0 3.694-.308 7.85-5.883 4.157-5.575 8.031-11.432 8.031-11.432l-25.297 9.377s4.233 7.938 9.416 7.938Z"
      fill="url(#logo-type-fa_svg__a)"
    />
    <Path
      d="M59.225 37.295s8.287-12.46 10.52-22.093c.897-4.804.461-11.175-6.415-10.893-6.876.283-12.315 8.966-19.96 8.966-7.646 0-13.47-8.966-20.552-8.966-5.31 0-7.363 6.191-6.824 9.12 1.693 10.456 17.934 33.243 17.934 33.243l25.297-9.377Z"
      fill="url(#logo-type-fa_svg__b)"
    />
    <Path
      d="M59.225 37.295s8.287-12.46 10.52-22.093c.897-4.804.461-11.175-6.415-10.893-3.925.154-6.03 2.492-10.262 4.984-.385.231-2.104 5.035-7.415 8.04-9.211 5.242-23.861 10.071-22.578 12.384.872 1.567 1.719 2.954 2.514 4.264 3.335 5.472 6.26 9.788 8.339 12.69l25.297-9.376Z"
      fill="url(#logo-type-fa_svg__c)"
    />
    <Path
      d="M58.224 5.902s3.9 7.861-.872 14.412c-4.772 6.55-16.394 12.331-30.583 15.594-10.16-16.082-11.263-22.556-10.673-25.125.59-1.952-1.411 13.256 12.444 10.764 13.854-2.492 20.294-9.685 20.294-9.685s3.104-1.619 3.54-2.081c.437-.462 5.645-3.88 5.85-3.88Z"
      fill="url(#logo-type-fa_svg__d)"
    />
    <Path
      d="m54.556 8.265 3.67-2.363s3.309 6.936 0 12.999c0 0 2.231-5.703-3.67-10.636Z"
      fill="url(#logo-type-fa_svg__e)"
    />
    <Path
      d="M72.877 78.841a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM76.426 78.765a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808Z"
      fill="#00469F"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.32 72.206V66.36c-.996 0-2.4 1.659-2.4 1.659v3.369c0 1.225-1.226 1.225-1.226 1.225H68.79V66.08l-4.545.051s-3.907.587-3.907 4.39 3.09 3.93 3.09 3.93h1.991c.766 0 .868.026.868.537 0 .51-1.098 1.99-3.09 2.399-.178.612.64 1.556 1.073 1.48 3.345-.664 4.341-3.471 4.341-3.956a.46.46 0 0 1 .46-.46h5.515c2.733 0 2.733-2.245 2.733-2.245Zm-11.031.408v-5.258h-1.251c-.332 0-2.17.434-2.17 2.629 0 2.756 1.736 2.629 1.736 2.629h1.685Z"
      fill="#00469F"
    />
    <Path
      d="M52.5 64.804a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM56.049 64.727a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808Z"
      fill="#00469F"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.964 72.206V66.36c-.996 0-2.4 1.659-2.4 1.659v3.369c0 1.225-1.226 1.225-1.226 1.225h-4.903V66.08l-4.545.051s-3.907.587-3.907 4.39 3.09 3.93 3.09 3.93h1.992c.766 0 .842.026.842.537 0 .51-1.072 1.99-3.064 2.399-.179.612.638 1.556 1.072 1.48 3.346-.664 4.316-3.497 4.316-3.956 0-.46.485-.46.485-.46h5.516c2.732 0 2.732-2.245 2.732-2.245Zm-11.056.408v-5.258h-1.226c-.332 0-2.17.434-2.17 2.629 0 2.756 1.736 2.629 1.736 2.629h1.66Z"
      fill="#00469F"
    />
    <Path
      d="M36.106 66.897s1.506-1.276 2.707 0c.102.102.076 4.951.076 4.951s0 2.4-2.553 2.4H29.44s-.791-.077-.791-.46c0 0-.358.46-.74.46h-6.997s-.767 4.21-6.231 4.21c-5.465 0-6.512-1.48-6.512-9.443h2.477v3.829s.332 4.338 3.882 4.338c3.55 0 3.932-4.313 3.932-4.313v-5.513s.639-1.225 2.375-1.225v5.002s.204 1.328 1.353 1.328h3.984s1.2.102 1.2-1.328v-4.109a1.84 1.84 0 0 1 2.451 0v4.365a1.352 1.352 0 0 0 1.354 1.072h4.136s.868-.077.868-.868-.076-4.696-.076-4.696ZM34.523 78.663a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM38.072 78.56a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.809Z"
      fill="#1C95A2"
    />
    <Path
      d="M24.258 78.612a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM27.807 78.535a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808ZM14.477 70.648a1.404 1.404 0 1 0 .001-2.808 1.404 1.404 0 0 0 0 2.808ZM36.285 81.7a1.404 1.404 0 1 0 0-2.808 1.404 1.404 0 0 0 0 2.808Z"
      fill="#1C95A2"
    />
    <Path d="M26.48 77.106h-.869v.16h.868v-.16Z" fill="#1C95A2" />
    <Defs>
      <LinearGradient
        id="logo-type-fa_svg__a"
        x1={44.16}
        y1={39.599}
        x2={52.318}
        y2={48.971}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.3} stopColor="#589C9A" />
        <Stop offset={0.77} stopColor="#458A9D" />
        <Stop offset={1} stopColor="#3A809E" />
      </LinearGradient>
      <LinearGradient
        id="logo-type-fa_svg__b"
        x1={15.912}
        y1={25.488}
        x2={70.091}
        y2={25.488}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#1C95A2" />
        <Stop offset={1} stopColor="#21989A" />
      </LinearGradient>
      <LinearGradient
        id="logo-type-fa_svg__c"
        x1={29.797}
        y1={40.653}
        x2={72.396}
        y2={11.954}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.21} stopColor="#063CA6" />
        <Stop offset={0.47} stopColor="#0A6CAC" />
        <Stop offset={0.83} stopColor="#10ABB5" />
        <Stop offset={1} stopColor="#12C4B8" />
      </LinearGradient>
      <LinearGradient
        id="logo-type-fa_svg__d"
        x1={15.965}
        y1={20.913}
        x2={59.728}
        y2={20.913}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#75A7CA" />
        <Stop offset={1} stopColor="#86C39F" />
      </LinearGradient>
      <LinearGradient
        id="logo-type-fa_svg__e"
        x1={54.561}
        y1={12.412}
        x2={59.703}
        y2={12.412}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#71B497" />
        <Stop offset={1} stopColor="#61A598" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default SvgLogoTypeFa;
